import { NgModule } from '@angular/core';
import { NotificationBellComponent } from './notification-bell.component';
import { SharedModule } from '../../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [NotificationBellComponent],
  imports: [
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatRippleModule,
  ],
  exports: [NotificationBellComponent],
})
export class NotificationBellModule {}
